import React, { Component } from 'react';
import Select from 'react-select';
import withRouter from "../../Utils/withRouter";
import Swal from "sweetalert2";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import { NavLink } from "react-router-dom";
import { currentDateAndTime, decodeData } from '../../Constants/constants';


const monthsoption = [
  { value: '0' , label: '0 Month' },
  { value: '1', label: '1 Month' },
  { value: '2', label: '2 Month' },
  { value: '3', label: '3 Month' },
  { value: '4', label: '4 Month' },
  { value: '5', label: '5 Month' },
  { value: '6', label: '6 Month' },
  { value: '7', label: '7 Month' },
  { value: '8', label: '8 Month' },
  { value: '9', label: '9 Month' },
  { value: '10', label: '10 Month' },
  { value: '11', label: '11 Month' },
];
class WorkExperience extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    // Initial state to store form data and validation errors
    this.state = {
      company_name: '',
      experience_period: '',
     
      experience_period: '',
      last_designation: '',
      last_ctc:'',
      employee_work_experience_references: '',
      designation: '',
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      loadingSubmit: false,
      keyword: "",
      from_date: "",
      employee_work_experience_id:"",
      experience_months: "",
      experience_years: "",
      to_date: "",
      decodedData: [],
      experience_months:"",
      experience_years:"",

      reference1: {
        name: '',
        contact: '',
        email: ''
      },
      reference2: {
        name: '',
        contact: '',
        email: ''
      },
      reference3: {
        name: '',
        contact: '',
        email: ''
      },
      errors: {} // Store validation errors
    };
    this.closeRef = React.createRef();
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }

  // Handler function to update state on input change
  handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  handleReferenceChange = (e, referenceName) => {
    const { name, value } = e.target;

    // Update the specific reference state
    this.setState((prevState) => ({
      [referenceName]: {
        ...prevState[referenceName],
        [name]: value
      }
    }));
  };

  // Handler function for Select component change
  handleSelectChange = (name, selectedOption) => {
    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };


  // Handler function for form submission
  handleSubmit = (e) => {
    e.preventDefault();
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const employee_id = this.props.params.employee_id;
    const errors = this.validateForm();
    console.log(`Object.keys(errors).length`, errors);
    if (Object.keys(errors).length > 0) {
      // If there are validation errors, update the state with the errors
      this.setState({ errors });
      return;
    }
    // this.setState({loadingSubmit:true});
    var formData = {
      employee_work_experience_id:this.state.employee_work_experience_id,
      employee_id: employee_id,
      company_name: this.state.company_name,
      last_designation: this.state.last_designation,
      experience_period: `${this.state.experience_years}${this.state.experience_months==="0"? "":`.${this.state.experience_months}`}`,
      date: currentDateAndTime(),
      last_ctc: this.state.last_ctc,
      employee_work_experience_references: [
        this.state.reference1,
        this.state.reference2,
        this.state.reference3
      ]
    };

    axios.post(`${apiURL}Employees/CreateEmployeeWorkExperience`, formData, { headers }).then((response) => {
      const { success } = response.data;

      if (success === true) {
        this.setState({
          company_name: '',
          experience_period: '',
          last_designation: '',
          last_ctc:'',
          employee_work_experience_references: '',
          last_designation: '',
          experience_period: '',
          last_CTC: '',
          employee_work_experience_document_references: '',
          // loadingList:true,
        });
        this.closeRef.current.click();

        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick:false
        })
      } else {
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick:false
        })
        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
      }

    }).catch((error)=>{
      console.log("Employees/CreateEmployeeWorkExperience ERROR:",error);
      Swal.fire({
        title: `<strong>Failed</strong>`,
        text: "Opps...! Something went wrong!",
        icon: 'error',
        showConfirmButton: true,
        allowOutsideClick:false
      })
    })
  };
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Employees/GetEmployeeWorkExperiences`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          employee_id: this.props.params.employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
            company_name: '',
            employee_work_experience: '',
            experience_period: '',
            experience_months: '',
            experience_years: '',
            last_designation: '',
            employee_work_experience_references: '',
            last_ctc: '',
            employee_work_experience_document_references: '',
            errors:{}
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };
  componentDidMount() {
      this.setState({ loadingList: true }, (prevState) => {
        this.GetList();
      });
    }
    componentDidUpdate(prevProps, prevState) {
      if (prevState.permissions !== this.context.permissions) {
        // console.log("Permissions Updated:", this.context.permissions);
          const { permissions } = this.context;
          if (permissions.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const encodedData = queryParams.get("abs");
            const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
            if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
              this.setState({ decodedData });
            }
          } else {
            console.warn("Permissions not yet available. Retrying...");
          }
      }
    }
  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to Delete this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          employee_work_experience_id: id,
          date: currentDateAndTime(),
        };
        axios
          .post(`${apiURL}Employees/DeleteEmployeeWorkExperience`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.success === true ? "Success" : "Failed"
                }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: true }, (prevState) => {
                this.GetList();
              });
            }
          })
          .catch((error) => {
            // Handle any errors that occur during the request
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
            });
          });
      }
    });
  };
  handleEdit= (row)=>{
    console.log("row===>",row)
    this.setState({
      employee_work_experience_id: row?.employee_work_experience_id,
      company_name: row?.company_name,
      experience_period: row?.experience_period,
      experience_years: Math.floor(row?.experience_period),
      experience_months: String(row?.experience_period).split(".")[1] || 0,
      
      last_designation: row?.last_designation,
      employee_work_experience: row?.employee_work_experience,
      last_ctc: row?.last_ctc,
      
      employee_work_experience_references: row?.employee_work_experience_references
      
      
    })
  }

  validateForm = () => {
    const errors = {};
    const numberRegex = /^\d+(\.\d+)?$/;
    const mobileRegex = /^[0-9]{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email format

    if (!this.state.company_name) errors.company_name = 'Previous Company Name is required';
    if (!this.state.last_designation) errors.last_designation = 'Designation is required';
    if (!this.state.experience_years) errors.experience_years = 'Experience years is required';
    if (!this.state.experience_months) errors.experience_months = 'Experience months is required';
    if (this.state.experience_years && !numberRegex.test(this.state.experience_years)) errors.experience_years = 'Experience years msut be a number';
    if (!this.state.last_ctc) errors.last_ctc = 'Last CTC is required';
    if (!numberRegex.test(this.state.last_ctc)) errors.last_ctc = 'Last CTC must be a number';

    const references = ['reference1', 'reference2', 'reference3'];

    references.forEach((reference, index) => {
      const ref = this.state[reference];
      const refErrors = {};

      if (ref && (ref.name || ref.contact || ref.email)) {
        if (!ref.name) refErrors.name = `Reference ${index + 1} Name is required`;
        if (!ref.contact) {
          refErrors.contact = `Reference ${index + 1} Contact is required`;
        } else if (!mobileRegex.test(ref.contact)) {
          refErrors.contact = `Reference ${index + 1} Contact is invalid`;
        }
        if (!ref.email) {
          refErrors.email = `Reference ${index + 1} Email is required`;
        } else if (!emailRegex.test(ref.email)) {
          refErrors.email = `Reference ${index + 1} Email must be a valid email address`;
        }
      }

      if (Object.keys(refErrors).length > 0) {
        errors[reference] = refErrors;
      }
    });

    return errors;
  };




  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList(); // This will log the updated state value
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList(); // This will log the updated state value
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList(); // This will log the updated state value
      }
    );
  };
  render() {
    const { errors } = this.state;

    return (
      <>
        <div className='d-flex justify-content-between align-items-center'>
          <div>
            <h5>Work Experience</h5>
          </div>
          <div>
            <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModalgrid" onClick={()=> this.GetList() }>
              <i className="ri-menu-add-fill" style={{ fontSize: "16px" }} />
            </button>
            <div className="modal fade" id="exampleModalgrid" tabIndex={-1} aria-labelledby="exampleModalgridLabel" aria-modal="true">
              <div className="modal-dialog modal-xl">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalgridLabel">Work Experience</h5>
                    <button type="button" className="btn-close" ref={this.closeRef} data-bs-dismiss="modal" aria-label="Close" />
                  </div>
                  <div className="modal-body">
                    <div className="container mt-2">
                      <form onSubmit={this.handleSubmit}>
                        {/* First Column */}
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="company_name" className="form-label">Previous Company Name:</label>
                            <input
                              type="text"
                              id="company_name"
                              name="company_name"
                              value={this.state.company_name}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.company_name ? 'is-invalid' : ''}`}
                              placeholder="Enter Previous Company Name"
                            />
                            {errors.company_name && <div className="invalid-feedback">{errors.company_name}</div>}
                          </div>



                          <div className="col-md-6 mb-3">
                            <label htmlFor="designation" className="form-label">  Designation:</label>
                            <input
                              type="text"
                              id="last_designation"
                              name="last_designation"
                              value={this.state.last_designation}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.designation ? 'is-invalid' : ''}`}
                              placeholder="Enter Designation"
                            />
                            {errors.last_designation && <div className="invalid-feedback">{errors.last_designation}</div>}
                          </div>
                        </div>

                        {/* Second Column */}

                        {/* Work Experience Input */}
                            <div className="row">
                             
                              <div className="col-12">
                                <label className="form-label">Work Experience:</label>
                              </div>

                           
                              <div className="col-md-3 mb-3">
                                <label htmlFor="experience_years" className="form-label">Years:</label>
                                <input
                                    type="number"
                                    id="experience_years"
                                    name="experience_years"
                                    min="0"
                                    value={this.state.experience_years}
                                    onChange={this.handleInputChange}
                                    className={`form-control ${errors.experience_years ? 'is-invalid' : ''}`}
                                    placeholder="Enter Years of Experience"
                                />

                                {errors.experience_years && <div className="invalid-feedback">{errors.experience_years}</div>}
                              </div>
                           
                              <div className="col-md-3 mb-3">
                              <label htmlFor="experience_months" className="form-label">Months:</label>
                              <Select
                                    id="experience_months"
                                    name="experience_months"
                                    value={monthsoption.find(option => option.value === this.state.experience_months)}
                                    onChange={(selectedOption) => this.handleSelectChange('experience_months', selectedOption)}
                                    options={monthsoption}
                                    placeholder="Select Months"
                               />

                              {errors.experience_months && <div className="invalid-feedback">{errors.experience_months}</div>}
                              </div>



                            {/* <div className="row">
                              <div className="col-md-6 mb-3">
                                <label htmlFor="experience_period" className="form-label">Work Experience:</label>
                                <input
                                  type="number"
                                  id="experience_period"
                                  name="experience_period"
                                  value={this.state.experience_period}
                                  onChange={this.handleInputChange}
                                  className={`form-control ${errors.experience_period ? 'is-invalid' : ''}`}
                                  placeholder="Enter Experience In Years"
                                />
                                {errors.experience_period && <div className="invalid-feedback">{errors.experience_period}</div>}
                              </div> */}


                              <div className="col-md-6 mb-3">
                                <label htmlFor="last_ctc" className="form-label">Last CTC (In Lpa):</label>
                                <input
                                  type="number"
                                  id="last_ctc"
                                  name="last_ctc"
                                  value={this.state.last_ctc}
                                  onChange={this.handleInputChange}
                                  className={`form-control ${errors.last_ctc ? 'is-invalid' : ''}`}
                                  placeholder="Enter Your Last CTC"
                                />
                                {errors.last_ctc && <div className="invalid-feedback">{errors.last_ctc}</div>}
                              </div>

                            </div>


                        <div className="row">
                          <div className="col-md-4 mb-3">
                            <label htmlFor="reference1_name" className="form-label">Reference Name 1:</label>
                            <input
                              type="text"
                              id="reference1_name"
                              name="name"
                              value={this.state.reference1.name}
                              onChange={(e) => this.handleReferenceChange(e, 'reference1')}
                              className={`form-control ${errors.reference1 && errors.reference1.name ? 'is-invalid' : ''}`}
                              placeholder="Enter Reference Name 1"
                            />
                            {errors.reference1 && errors.reference1.name && <div className="invalid-feedback">{errors.reference1.name}</div>}
                          </div>
                          <div className="col-md-4 mb-3">
                            <label htmlFor="reference1_contact" className="form-label">Reference Contact 1:</label>
                            <input
                              type="number"
                              id="reference1_contact"
                              name="contact"
                              value={this.state.reference1.contact}
                              onChange={(e) => this.handleReferenceChange(e, 'reference1')}
                              className={`form-control ${errors.reference1 && errors.reference1.contact ? 'is-invalid' : ''}`}
                              placeholder="Enter Reference Contact 1"
                            />
                            {errors.reference1 && errors.reference1.contact && <div className="invalid-feedback">{errors.reference1.contact}</div>}
                          </div>
                          <div className="col-md-4 mb-3">
                            <label htmlFor="reference1_email" className="form-label">Reference Email 1:</label>
                            <input
                              type="email"
                              id="reference1_email"
                              name="email"
                              value={this.state.reference1.email}
                              onChange={(e) => this.handleReferenceChange(e, 'reference1')}
                              className={`form-control ${errors.reference1 && errors.reference1.email ? 'is-invalid' : ''}`}
                              placeholder="Enter Reference Email 1"
                            />
                            {errors.reference1 && errors.reference1.email && <div className="invalid-feedback">{errors.reference1.email}</div>}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-4 mb-3">
                            <label htmlFor="reference2_name" className="form-label">Reference Name 2:</label>
                            <input
                              type="text"
                              id="reference2_name"
                              name="name"
                              value={this.state.reference2.name}
                              onChange={(e) => this.handleReferenceChange(e, 'reference2')}
                              className={`form-control ${errors.reference2 && errors.reference2.name ? 'is-invalid' : ''}`}
                              placeholder="Enter Reference Name 2"
                            />
                            {errors.reference2 && errors.reference2.name && <div className="invalid-feedback">{errors.reference2.name}</div>}
                          </div>
                          <div className="col-md-4 mb-3">
                            <label htmlFor="reference2_contact" className="form-label">Reference Contact 2:</label>
                            <input
                              type="number"
                              id="reference2_contact"
                              name="contact"
                              value={this.state.reference2.contact}
                              onChange={(e) => this.handleReferenceChange(e, 'reference2')}
                              className={`form-control ${errors.reference2 && errors.reference2.contact ? 'is-invalid' : ''}`}
                              placeholder="Enter Reference Contact 2"
                            />
                            {errors.reference2 && errors.reference2.contact && <div className="invalid-feedback">{errors.reference2.contact}</div>}
                          </div>
                          <div className="col-md-4 mb-3">
                            <label htmlFor="reference2_email" className="form-label">Reference Email 2:</label>
                            <input
                              type="email"
                              id="reference2_email"
                              name="email"
                              value={this.state.reference2.email}
                              onChange={(e) => this.handleReferenceChange(e, 'reference2')}
                              className={`form-control ${errors.reference2 && errors.reference2.email ? 'is-invalid' : ''}`}
                              placeholder="Enter Reference Email 2"
                            />
                            {errors.reference2 && errors.reference2.email && <div className="invalid-feedback">{errors.reference2.email}</div>}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-4 mb-3">
                            <label htmlFor="reference3_name" className="form-label">Reference Name 3:</label>
                            <input
                              type="text"
                              id="reference3_name"
                              name="name"
                              value={this.state.reference3.name}
                              onChange={(e) => this.handleReferenceChange(e, 'reference3')}
                              className={`form-control ${errors.reference3 && errors.reference3.name ? 'is-invalid' : ''}`}
                              placeholder="Enter Reference Name 3"
                            />
                            {errors.reference3 && errors.reference3.name && <div className="invalid-feedback">{errors.reference3.name}</div>}
                          </div>
                          <div className="col-md-4 mb-3">
                            <label htmlFor="reference3_contact" className="form-label">Reference Contact 3:</label>
                            <input
                              type="number"
                              id="reference3_contact"
                              name="contact"
                              value={this.state.reference3.contact}
                              onChange={(e) => this.handleReferenceChange(e, 'reference3')}
                              className={`form-control ${errors.reference3 && errors.reference3.contact ? 'is-invalid' : ''}`}
                              placeholder="Enter Reference Contact 3"
                            />
                            {errors.reference3 && errors.reference3.contact && <div className="invalid-feedback">{errors.reference3.contact}</div>}
                          </div>
                          <div className="col-md-4 mb-3">
                            <label htmlFor="reference3_email" className="form-label">Reference Email 3:</label>
                            <input
                              type="email"
                              id="reference3_email"
                              name="email"
                              value={this.state.reference3.email}
                              onChange={(e) => this.handleReferenceChange(e, 'reference3')}
                              className={`form-control ${errors.reference3 && errors.reference3.email ? 'is-invalid' : ''}`}
                              placeholder="Enter Reference Email 3"
                            />
                            {errors.reference3 && errors.reference3.email && <div className="invalid-feedback">{errors.reference3.email}</div>}
                          </div>
                        </div>

                        {/* <div className="d-flex justify-content-end">
                        {!this.state.loadingSubmit?
                          <button type="submit" className="btn btn-success btn-label waves-effect right waves-light">
                            <i className="bx bx-save label-icon align-middle fs-16 ms-2" /> Save </button>:
                            <button className="btn btn-success btn-load">
                            <span className="d-flex align-items-center">
                                <span className="spinner-border flex-shrink-0" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </span>
                                <span className="flex-grow-1 ms-2">
                                    Saving...
                                </span>
                            </span>
                          </button>
  }
                        </div> */}
                        <div className="d-flex justify-content-end">
                          <button type="submit" className={`btn btn-${this.state.employee_work_experience_id? "primary":"success"} btn-label waves-effect right waves-light`}>
                            <i className="bx bx-save label-icon align-middle fs-16 ms-2" />{this.state.employee_work_experience_id? "Update":"Save"} </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <table className={`table table-bordered table-stripped`}>
            <thead className="table-light">
              <tr>
                <th width={'190'} >Previous Company Name</th>
                <th width={'160'} >Previous Designation</th>
                <th width={'200'} >Work Experience</th>
                <th width={'150'} >Last CTC</th>
                <th width={'200'} >References</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {this.state.rows.map((row) => {
                var references_obj = JSON.parse(row.employee_work_experience_references);
                return (
                  <tr key={row.employee_work_experience_id}>
                    <td>{row.company_name}</td>
                    <td>{row.last_designation}</td>
                    {/* <td>{row.experience_period}</td> */}
                    <td>
                      {parseFloat(row.experience_period) > 1 ? `${row.experience_period} Years`: `${row.experience_period} Year`}
                      {/* {row.experience_months > 0 && (
                        <span>{row.experience_months} Month{row.experience_months > 1 ? 's' : ''}</span>
                      )} */}
                    </td>

                   
                    <td>{row.last_ctc}</td>
                    <td>


                      <div>
                        <ol style={{paddingLeft:"10px"}}>
                          {Object.entries(references_obj).map(([key, value], index) => (
                            <li key={index}>
                              {value.name !== '' && (
                                <>
                                  <h6 style={{marginBottom:"0px"}}>{value.name}</h6>
                                  <br />
                                  <small>Contact: {value.contact}</small>
                                  <br />
                                  <small>Email: {value.email}</small>
                                  <hr />
                                </>
                              )}
                            </li>
                          ))}
                        </ol>
                      </div>

                    </td>
                    <td className="d-flex justify-content-around gap-2">
                    <button
                           onClick={() =>
                            this.handleEdit(row)
                            
                            
                        }
                              data-bs-toggle="modal" data-bs-target="#exampleModalgrid"
                                className="btn-icon btn btn-sm btn-outline-primary">
                                <i className="ri-edit-box-line"></i>
                          </button>
                      <button
                        onClick={() =>
                          this.handleDelete(row.employee_work_experience_id)
                        }
                        className="btn-icon btn btn-sm btn-outline-danger"
                      >

                        <i className="ri-delete-bin-line"></i>
                      </button>
                    </td>
                    {/* <td >
                      <div className="d-flex justify-content-around">

                        <button
                          onClick={() =>
                            this.handleDelete(row.employee_work_experience_id)
                          }
                          className="btn-icon btn btn-sm btn-outline-danger"
                        >
                          <i className="ri-delete-bin-line"></i>{" "}
                        </button>
                      </div>
                    </td> */}
                    {/* <td className="d-flex justify-content-around gap-2">
                    <button
                           onClick={() =>
                            this.handleEdit(row)
                        }
                              data-bs-toggle="modal" data-bs-target="#exampleModalgrid"
                                className="btn-icon btn btn-sm btn-outline-primary">
                                <i className="ri-edit-box-line"></i>
                          </button>
                       <button
                        onClick={() =>
                          this.handleDelete(row.employee_id)
                        }
                        className="btn-icon btn btn-sm btn-outline-danger"
                      >

                        <i className="ri-delete-bin-line"></i>
                      </button> 
                    </td> */}
                  </tr>
                );
              })}
            </tbody>
            <tfoot className="table-light">
              <tr>
                <th colSpan={6}>
                  <div className="d-flex justify-content-between">
                    <button
                      disabled={this.state.prev === false && this.state.loadingList === false ? true : false}
                      type="button"
                      onClick={() => this.handlePrev()}
                      className={`btn btn-warning btn-label waves-effect waves-light`}
                    >
                      <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                      Previous
                    </button>
                    <div
                      className="col-md-4"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      {
                        <small>
                          Total Records: {this.state.total_records} |
                          Total Pages: {this.state.total_pages} |
                          Current Page: {this.state.page}
                        </small>
                      }
                    </div>
                    <div className="col-md-2">
                      <select
                        className="form-select"
                        onChange={(e) => this.handleChange(e)}
                      >
                        {Array.from(
                          { length: this.state.total_pages },
                          (_, i) => (
                            <option
                              selected={this.state.page === i + 1}
                              key={i}
                              value={i + 1}
                            >
                              Page {i + 1}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                    <button
                      disabled={
                        this.state.next === false &&
                          this.state.loadingList === false
                          ? true
                          : false
                      }
                      type="button"
                      onClick={() => this.handleNext()}
                      className={`btn btn-primary btn-label waves-effect right waves-light`}
                    >
                      <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />{" "}
                      Next
                    </button>
                  </div>
                </th>
              </tr>
            </tfoot>
          </table>
        </div>
      </>
    );
  }
}

export default withRouter(WorkExperience);
